import Container from '@/components/atoms/Container'
import { MatriculateCourses } from './Courses'

export function Matriculate() {
	return (
		<div className='flex w-full'>
			<Container>
				<div className='flex flex-col w-full 2lg:grid 2lg:grid-cols-1 justify-between gap-6'>
					<MatriculateCourses />
				</div>
			</Container>
		</div>
	)
}
